import "react-toastify/dist/ReactToastify.css";

import dayjs from "dayjs";
import { useEffect } from "react";

import { LandingCard } from "./Components";
import { useInfo } from "./context/InfoProvider/InfoProvider";
import { useAnalytics } from "./hooks/useAnalytics";
import Routes from "./Routes/Routes";
import { formatDate } from "./shared/utils/formatDate";
import { useSentryUser } from "./hooks/useSentryUser";

const LandingPage = () => {
  return (
    <LandingCard>
      <Routes />
    </LandingCard>
  );
};

const App = () => {
  const { identifyUser, identifyGroup, latestDataAvailable } = useAnalytics();
  const { auth0User: user, currentOrganization: org, tree, intercomUserJwt } = useInfo();

  useSentryUser();

  useEffect(() => {
    const extra = tree?.getNodeTreeExtras();
    const maxDate = extra && formatDate(dayjs(extra[0]?.max_date));
    if (user && org?.insightsTenantId) {
      identifyUser(
        user.email!,
        user.given_name!,
        user.family_name!,
        org.insightsTenantId,
        intercomUserJwt
      );
      identifyGroup(org.insightsTenantId);
    }
    if (maxDate) {
      latestDataAvailable(maxDate);
    }
  }, [
    user,
    org?.insightsTenantId,
    intercomUserJwt,
    identifyUser,
    identifyGroup,
    latestDataAvailable,
  ]);

  return <LandingPage />;
};

export default App;
